import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
import store from '../store/index'

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Index.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('@/views/Main.vue'),
    children: [
      {
        path: 'detail/:id',
        name: 'detail',
        meta: {
          requiredAuth: true,
        },
        component: () => import('@/views/Detail.vue')
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/Search.vue')
      },
      {
        path: 'copyright',
        name: 'copyright',
        component: () => import('@/views/Copyright.vue')
      },
      {
        path: 'about/agree',
        name: 'agree',
        component: () => import('@/views/about/agree.vue')
      },
      {
        path: 'about/policy',
        name: 'policy',
        component: () => import('@/views/about/policy.vue')
      },
      {
        path: 'about/safe',
        name: 'safe',
        component: () => import('@/views/about/safe.vue')
      },
      {
        path: 'about/version',
        name: 'version',
        component: () => import('@/views/about/version.vue')
      },
    ]
  },
  
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  if (location.pathname != '/') location.href = '/#/main' + location.pathname + location.search
  if (window._hmt) {
    if (to.path) {
      window._hmt.push([window.location.pathname + '#' + to.fullPath])
    }
  }

  if (to.name == 'search') {
    const { filter } = store.state
    const query = to.query
    if (filter.time !== -1 || filter.size !== -1 || filter.type !== -1 || filter.searchtype !==-1) {
      if (query.size !== undefined || query.time !== undefined || query.type !== undefined || query.searchtype !== undefined) {
        next()
      } else {
        if (filter.size !== -1) {
          query.size = filter.size
        }
        if (filter.time !== -1) {
          query.time = filter.time
        }
        if (filter.type !== -1) {
          query.type = filter.type
        }
        if (filter.searchtype !== -1) {
          query.searchtype = filter.searchtype
        }

        next({ path: '/main/search', query })
      }
    } else {
      next()
    }
  }
  next()
})

export default router
